module.exports = __webpack_public_path__ + "static/media/Artboard6.07131786.png";